//项目管理页面接口
import request from '../request.js'


//新增材料  昂少强  
const addM = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceMaterials/resourceMaterialsSave',
    })
}
//材料修改  昂少强   
const updateMaterials = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceMaterials/update',
    })
}
//材料表回显  昂少强   
const getMaterials = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceMaterials/getMaterials',
    })
}
//材料删除  昂少强   
const delMaterials = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceMaterials/deleteM',
    })
}
//新增工种    
const addL = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceProfessionals/resourceProfessionalsSave',
    })
}
//工种回显 昂少强   
const getLabor = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceProfessionals/getLabor',
    })
}
//工种修改 昂少强
const updateLabor = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceProfessionals/update',
    })
}
//工种删除  昂少强   
const delLabor = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceProfessionals/deleteL',
    })
}

//查询材料列表（叶凡）
const getPageMaterials = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceMaterials/getPageMaterials',
    })
}

//查询不同人员的主要材料列表（叶凡）
const getMainMaterials = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesForUsers/getMainMaterials',
    })
}

//保存不同人员的主要材料列表（叶凡）
const saveMainMaterials = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesForUsers/saveMainMaterials',
    })
}

//查询材料指定月份价格信息列表（叶凡）
const getPricesOfMaterials = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/getPricesOfMaterials',
    })
}

// 查询走势 接口（叶凡）
const getPricesOfTrend = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/getPricesTrend',
    })
}

// 查询 同比/环比 接口（叶凡）
const getPricesOfCompare = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/getPricesCompare',
    })
}

// 保存资源组合 接口（叶凡）
const saveResourceCombination = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceCombination/saveResourceCombination',
    })
}

// 删除资源组合 接口（叶凡）
const deleteResourceCombination = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceCombination/deleteResourceCombination',
    })
}

// 获取资源组合列表 接口（叶凡）
const getResourceCombinations = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceCombination/getResourceCombinations',
    })
}

// 获取材料分类 接口（叶凡）
const getMaterialCategorys = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceMaterials/getMaterialCategorys',
    })
}

// 根据材料类型查询材料列表 接口（叶凡）
const getMaterialsByType = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceMaterials/getMaterialsByType',
    })
}

// 查询材料组合列表 接口（叶凡）
const getPageConbinations = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourceMaterials/getPageConbinations',
    })
}

//删除主要材料（叶凡）
const deleteMainMaterial = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesForUsers/deleteMainMaterial',
    })
}


export {
    addM,
    addL,
    delLabor,
    getLabor,
    updateLabor,
    delMaterials,
    getMaterials,
    updateMaterials,
    getMainMaterials,
    getPricesOfTrend,
    getPageMaterials,
    saveMainMaterials,
    getPricesOfCompare,
    getMaterialsByType,
    deleteMainMaterial,
    getPageConbinations,
    getMaterialCategorys,
    getPricesOfMaterials,
    saveResourceCombination,
    getResourceCombinations,
    deleteResourceCombination,
}